import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@store/theme/design";
import { contentSpacingStyles } from "@store/theme/mixins/common";
import { transitionHoverStyles } from "@store/theme/mixins/transition";
import { css } from "styled-components";

export const titleSpacingStyles = () => {
    return contentSpacingStyles("1em", "0.5em");
};

export const linkStyles = (color = "text.link", hoverColor = "text.linkHover") => {
    return css`
        ${transitionHoverStyles("color")}
        color: ${getColor(color)};

        &:active,
        &:visited {
            color: ${getColor(color)};
        }

        &:hover {
            color: ${getColor(hoverColor)};
            text-decoration: none;
        }
    `;
};

export const editLinkStyles = () => {
    return css`
        ${getProp("theme.link.defaultProps.css")}
        font-size: ${TYPOGRAPHY.size.smaller};
        font-weight: ${TYPOGRAPHY.weight.bold};
    `;
};

export const skuNumber = () => {
    return css`
        color: ${COLORS.text.light};
        font-size: ${TYPOGRAPHY.size.smaller};
        text-transform: uppercase;
    `;
};

export const labelSeparationStyles = () => {
    return css`
        position: relative;
        padding-right: 11px;
        margin-right: 10px;

        &::after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 0.8em;
            background-color: ${getColor("common.borderDark")};
            transform: translateY(-50%);
        }
    `;
};
